import { render, staticRenderFns } from "./PurchaseJournalCard.vue?vue&type=template&id=55b710de"
import script from "./PurchaseJournalCard.vue?vue&type=script&lang=js"
export * from "./PurchaseJournalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports